// extracted by mini-css-extract-plugin
export const articler = "styles-module--articler--1vPcq";
export const toggleButton = "styles-module--toggleButton--2noNf";
export const tabs = "styles-module--tabs--2p5XQ";
export const active = "styles-module--active--3WdhG";
export const overlay = "styles-module--overlay--3ltcb";
export const activeOverlay = "styles-module--activeOverlay--vZZSU";